import { store } from "redux/store";
import {
    COMMON_SERVICES
} from '../../../redux/reduxToolkitServices/_commonServices/commonServices';


const saveCourseRotationSetsData = (courseRotationSetsDto, log) => {
    const { appDataReduxState:{siteNumberData} = {} } = store.getState().firstReducer
    let data = JSON.stringify({
        SiteId: Number(siteNumberData),
        CourseRotationSetsDto: courseRotationSetsDto,
        Log: log
    })
    store.dispatch(COMMON_SERVICES.updatePinRotationDataServices(data))
}

export const datacontext = {
    saveCourseRotationSetsData
}